export const SEARCH_REGIONS: readonly { key: string; label: string }[] = [
  { key: 'abruzzo', label: 'Abruzzo' },
  { key: 'basilicata', label: 'Basilicata' },
  { key: 'calabria', label: 'Calabria' },
  { key: 'campania', label: 'Campania' },
  { key: 'emiliaromagna', label: 'Emilia-Romagna' },
  { key: 'friuliveneziagiulia', label: 'Friuli-Venezia Giulia' },
  { key: 'lazio', label: 'Lazio' },
  { key: 'liguria', label: 'Liguria' },
  { key: 'lombardia', label: 'Lombardia' },
  { key: 'marche', label: 'Marche' },
  { key: 'molise', label: 'Molise' },
  { key: 'piemonte', label: 'Piemonte' },
  { key: 'puglia', label: 'Puglia' },
  { key: 'sardegna', label: 'Sardegna' },
  { key: 'sicilia', label: 'Sicilia' },
  { key: 'toscana', label: 'Toscana' },
  { key: 'trentinoaltoadige', label: 'Trentino-Alto Adige' },
  { key: 'umbria', label: 'Umbria' },
  { key: 'valledaosta', label: "Valle d'Aosta" },
  { key: 'veneto', label: 'Veneto' },
];
